export const suppressEmployerOnboardingBankInfo = false;
export const suppressInviteEmailLink = false;
export const validateEmployeeEmailLength = true;
export const disableEmployeeEdit = false;
export const employerCustodianInfoTemplate = "UmbOnboardingInfo";
export const displayBankAccountHolds = false;
